module.exports = __webpack_public_path__ + "static/img/Send14.68df67a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Send14.png
// module id = 4mhU
// module chunks = 0